export function extractRtkErrorMessage(err: any, fallback: string): string {
  const msg =
    err?.data?.message ??
    err?.message ??
    err?.error ??
    (Array.isArray(err?.data?.messages) ? err.data.messages[0] : undefined);

  return typeof msg === "string" && msg.trim().length > 0 ? msg : fallback;
}

const CLIENT_ERROR_STATUS_MIN: number = 400;
const SERVER_ERROR_STATUS_MIN: number = 500;

const statusOf = (err: unknown): unknown =>
  typeof err === "object" && err !== null && "status" in err
    ? err.status
    : undefined;

export function userFacingErrorMessage(err: unknown, fallback: string): string {
  const status: unknown = statusOf(err);

  const isBusinessRefusal: boolean =
    typeof status === "number" &&
    status >= CLIENT_ERROR_STATUS_MIN &&
    status < SERVER_ERROR_STATUS_MIN;

  if (!isBusinessRefusal) return fallback;

  return extractRtkErrorMessage(err, fallback);
}
